<template>
  <div class="id-container">
    <div class="info-content">
      <div class="tabs">
        <template v-if="!loading">
          <div v-if="!stepInfo.isFollowBatch" class="tab" :class="{'active': tabStep === 1}" @click="tabStep = 1">
            <img v-if="tabStep === 1" src="../../../../../../assets/icons/icon_face1.png" alt="">
            <img v-else src="../../../../../../assets/icons/icon_face.png" alt="">
            <span>人证核验<i v-if="stepInfo.passCardVerify" class="el-icon-check"></i></span>
          </div>
          <div class="tab" :class="{'active': tabStep === 2}" @click="tabStep = 2">
            <img v-if="tabStep === 2" src="../../../../../../assets/icons/icon_review1.png" alt="">
            <img v-else src="../../../../../../assets/icons/icon_review.png" alt="">
            <span>报名表审核<i v-if="+stepInfo.verifyResult" class="el-icon-check"></i></span>
          </div>
          <div v-if="!stepInfo.isFollowBatch" class="tab" :class="{'active': tabStep === 3}" @click="tabStep = 3">
            <img v-if="tabStep === 3" src="../../../../../../assets/icons/icon_Pay1.png" alt="">
            <img v-else src="../../../../../../assets/icons/icon_Pay.png" alt="">
            <span>报名缴费<i v-if="+stepInfo.feeResult" class="el-icon-check"></i></span>
          </div>
          <div v-if="!stepInfo.isFollowBatch" class="tab" :class="{'active': tabStep === 4}" @click="tabStep = 4">
            <img v-if="tabStep === 4" src="../../../../../../assets/icons/icon_exam1.png" alt="">
            <img v-else src="../../../../../../assets/icons/icon_exam.png" alt="">
            <span>考试信息</span>
          </div>
        </template>
      </div>
      <div class="content">
        <portrait v-if="tabStep === 1 && !stepInfo.passCardVerify" :student-id="studentId" :isView="true"></portrait>
        <viewPortrait v-else-if="tabStep === 1" :student-id="studentId" :isView="true"></viewPortrait>
        <qualificationReview v-else-if="tabStep === 2" :student-id="studentId" :isView="true" :verifyResult="stepInfo.verifyResult" @qualification-pass="qualificationPass"></qualificationReview>
        <registrationPayment v-else-if="tabStep === 3" :student-id="studentId" :feeResult="+stepInfo.feeResult" :isView="true" @fee-change="feeChange"></registrationPayment>
        <examInfo v-else-if="tabStep === 4" :student-id="studentId"></examInfo>
      </div>
    </div>
  </div>
</template>

<script>
import examInfo from './examInfo.vue'
import qualificationReview from './qualificationReview.vue'
import viewPortrait from './viewPortrait.vue'
import portrait from './portrait.vue'
import registrationPayment from './registrationPayment.vue'
export default {
  components: {
    registrationPayment,
    viewPortrait,
    qualificationReview,
    examInfo,
    portrait
  },
  props: {
    visible: Boolean
  },
  data () {
    return {
      loading: false,
      studentId: '',
      tabStep: 1,
      reader: {
        fetching: false
      },
      stepInfo: {}
    }
  },
  methods: {
    getStepInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/student/verifyInfo',
        method: 'post',
        data: this.$qs.stringify({
          studentId: this.studentId
        })
      }).then(response => {
        if (response.data) {
          const data = response.data
          if (data.errorCode === 0) {
            this.stepInfo = data.verifyInfo
            if (this.stepInfo.isFollowBatch) {
              this.tabStep = 2
            } else {
              this.tabStep = 1
            }
          } else {
            this.$message.error(data.message || '获取步骤信息失败')
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    qualificationPass (val) {
      this.stepInfo.verifyResult = val
    },
    feeChange (val) {
      this.stepInfo.feeResult = val
    }
  },
  watch: {
    'visible': {
      handler (val) {
        if (val) {
          this.studentId = this.$attrs['extra-id']
          this.tabStep = 1
          this.getStepInfo()
        } else {
          this.tabStep = 0
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.id-container {
  width: 1000px;
  & > .info-content {
    width: 100%;
    height: 100%;
    background-color: #0D59A7;
    background-image: url("../../../../../../assets/icons/background.png");
    background-repeat: no-repeat;
    background-size: 130px;
    background-position: 94% top;
    & > .tabs {
      display: flex;
      justify-content: center;
      height: 84px;
      align-items: center;
      & > .tab {
        width: 150px;
        height: 100%;
        color: #9EBDDC;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        & > img {
          width: 28px;
          height: 28px;
          margin-bottom: 5px;
        }
        span {
          margin-right: 5px;
         i {
           color: #70B603;
           margin-left: 3px;
         }
        }
      }
      & > .active {
        color: #fff;
      }
    }
    & > .content {
      width: 100%;
      background-color: #fff;
      margin: 0 auto;
      overflow: hidden;
      border-top-left-radius: 14px;
      border-top-right-radius: 14px;
    }
  }
  .blue-title {
    color: #0D59A7;
    position: relative;
    font-weight: 550;
    padding-left: 10px;
    font-size: 13px;

    &::before {
      content: '';
      display: inline-block;
      width: 3px;
      height: 20px;
      background-color: #02A7F0;
      margin-right: 10px;
      position: absolute;
      left: 2px;
    }
  }
}
</style>
